var search_song = {
	selectors: { },

	init: function () {
		var self = this;

        self.spotifySearch();
		self.loadSongs();
	},

    selectSong() {
		const liElements = document.querySelectorAll('.js-song_results li');
		
		liElements.forEach(li => {
			li.addEventListener('click', () => {
				const name = li.querySelector('strong').innerText.trim();
				const artist = li.querySelector('span').innerText.trim();
				const image = li.querySelector('img').src;


				
				document.querySelector('.js-bandName').value = artist;

				document.getElementsByName('song')[0].value = name;
				document.querySelector('.js-song_results').innerHTML = '';

				document.querySelector('.js-song_name').innerHTML = name;
				document.querySelector('.js-song_artist').innerHTML = artist;
			});
		});
	},

	loadSongs: function() {
		jQuery( '.js-loadSongs' ).on( 'click', function( e){
			e.preventDefault();
			jQuery('.js-song_results li.d-none').slice(0, 8).removeClass('d-none');

			if ( jQuery('.js-loadSongs').length === 0 ) {
				jQuery(this).hide();
			}
		});
	},

	spotifySearch: function() {
        let queryInput = document.getElementsByName('song')[0];
		let debounceTimeout = null;

		let self = this;

        if( !queryInput ) {  return; }

        queryInput.addEventListener('input', (e) => {
            e.preventDefault();

			if (debounceTimeout) {
				clearTimeout(debounceTimeout);
			}

			debounceTimeout = setTimeout(() => {
				let formData = new FormData();
				formData.append( 'action', 'get_songs' );
				formData.append( 'nonce', sikmoVars.nonce );
				formData.append( 'query', queryInput.value );

				fetch( sikmoVars.ajax_url, {
					method: 'POST',
					credentials: 'same-origin', 
					body: formData
				})
				.then( response => response.json() )
				.then( data => {

					const songList = document.querySelector('.js-song_results');
					songList.innerHTML = '';


					data.data.forEach((track, index) => {
						const li = document.createElement('li');
					
						// Pokud je index 8 nebo vyšší, přidej třídu d-none
						if (index >= 8) {
							li.classList.add('d-none');
						}
					
						li.innerHTML = `
							<a>
								<img src="${track.image}" alt="${track.name}">
								<p>
									<strong>${track.name}</strong><br>
									<span>${track.artist}</span><br>
								</p>
							</a>
						`;
					
						songList.appendChild(li);
					});

					self.selectSong();
				
				})
				.catch( error => console.error('Error:', error)) ;
			}, 300);
        });
	},
};

export { search_song };


